import { ProductIdOverrideFilter } from './ProductIdOverrideFilter'
import type { ProductIdOverrideFilterDataAccessObject } from './ProductIdOverrideFilterDataAccessObject'

export class ProductIdOverrideFilterEncoder {
  static encode(
    instance: ProductIdOverrideFilter,
  ): ProductIdOverrideFilterDataAccessObject {
    return {
      name: instance.name.value,
      entries: instance.entries.value,
    }
  }

  static decode(
    properties: ProductIdOverrideFilterDataAccessObject,
  ): ProductIdOverrideFilter {
    return new ProductIdOverrideFilter(properties.name, properties.entries)
  }
}
